import {
  ITransportVehicle,
  ICreateTransportVehicleRequest,
  IUpdateTransportVehicleRequest,
} from '../interfaces/heavyDutyMachinery/ITransportVehicle';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

// Same separate-host convention as HeavyDutyMachineryService's own heavyDutyMachineryBaseUrl.
const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

/** A host's own transport fleet -- see TransportVehicleController.GetMyTransportVehicles. */
export const getMyTransportVehicles = async (): Promise<ITransportVehicle[]> => {
  const response = await apiService<ITransportVehicle[]>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLES,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load your transport vehicles');
};

export const createTransportVehicle = async (request: ICreateTransportVehicleRequest): Promise<ITransportVehicle> => {
  const response = await apiService<ITransportVehicle>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLES,
    method: HTTP_METHODS.POST,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to create transport vehicle');
};

/** Also how a host deactivates one (request.isActive = false) -- see IUpdateTransportVehicleRequest's own doc comment. */
export const updateTransportVehicle = async (id: string, request: IUpdateTransportVehicleRequest): Promise<ITransportVehicle> => {
  const response = await apiService<ITransportVehicle>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_BY_ID(id),
    method: HTTP_METHODS.PUT,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to update transport vehicle');
};

/** Real delete -- rejected by the backend with a friendly message if it's assigned to a machine's delivery settings; unassign and deactivate it instead (see updateTransportVehicle). */
export const deleteTransportVehicle = async (id: string): Promise<void> => {
  const response = await apiService<{ message: string }>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_TRANSPORT_VEHICLE_BY_ID(id),
    method: HTTP_METHODS.DELETE,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (!response.success) throw new Error(response.error || 'Failed to delete transport vehicle');
};
